var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWear3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9733 27.8741L71.0001 80.1297L60.9728 80.7788C57.9395 68.8044 56.3897 55.3597 52.9192 43.5972C52.6278 42.617 53.2901 42.4315 51.5681 42.617L43.4351 80.7126L42.5476 80.845L34.1099 79.7191L37.5009 27.8741H66.9865H66.9733Z",
    fill: "#0256B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2977 23.1849V26.5362H38.2426L38.1499 23.1849H66.2977Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear3);
export default __webpack_public_path__ + "static/media/wear3.9b15bb94129c470a6271a0a5bfb3a940.svg";
export { ForwardRef as ReactComponent };